import axios from "axios";

const actions = {
  getManagedInstructionLocal(context, value) {
    return axios
      .get("managedInstructionLocal/" + value._id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  resetManagedInstructionLocalStep(context, value) {
    return axios
      .patch(`managedInstructionLocal/${value._id}/${value.stepId}/reset`)
      .then(function (res) {
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateManagedInstructionLocal(context, value) {
    return axios
      .patch("managedInstructionLocal/" + value._id, value.payload)
      .then(function (res) {
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
